import { BlocksDocument as c } from "./blocks-document.js";
import { BLOCK_TYPES as r, NO_MARGIN_CLASS as u, HORIZONTAL_RULE_FALLBACK as p, DEFAULT_ALIGNMENT as h } from "./constants.js";
import { TextSerializer as o } from "./text-serializer.js";
import { escape as d } from "./utils/escape.js";
class g {
  config;
  schema;
  customHandlers;
  constructor(t, e) {
    this.config = t, this.schema = e, this.customHandlers = /* @__PURE__ */ new Map();
    for (const s of t.customBlockHandlers ?? [])
      this.customHandlers.set(s.type, s);
  }
  serialize(t) {
    if (t.type.name !== "doc")
      throw new Error("Must provide an entire document to serialize");
    return this.serializeFragment(t.content);
  }
  serializeSlice(t) {
    return this.serializeFragment(t.content);
  }
  serializeFragment(t) {
    const e = [];
    return t.forEach((s) => {
      const i = this.serializeBlock(s);
      i && e.push(i);
    }), new c(e);
  }
  serializeBlock(t) {
    const e = t.attrs.type, s = this.customHandlers.get(e);
    if (s)
      return s.serialize(t, this);
    switch (t.attrs.type) {
      case r.PARAGRAPH:
      case r.HEADING:
      case r.SUBHEADING:
      case r.SUBHEADING3:
      case r.SUBHEADING4:
      case r.SMALL:
      case r.CODE:
        return this.serializeTextBlock(t);
      case r.IF_ELSE_STATEMENT:
        return this.serializeIfElseStatement(t);
      case r.IMAGE:
        return this.isIncompleteUpload(t.attrs.src) ? void 0 : this.serializeAsImage(t);
      case r.IMAGE_TEXT:
        return this.serializeAsImageText(t);
      case r.ORDERED_LIST:
      case r.UNORDERED_LIST:
        return this.serializeAsList(t);
      case r.VIDEO:
        return this.serializeAsVideo(t);
      case r.VIDEO_FILE:
        return this.serializeAsVideoFile(t);
      case r.AUDIO_FILE:
        return this.serializeAsAudioFile(t);
      case r.BUTTON:
        return this.serializeAsButton(t);
      case r.HORIZONTAL_RULE:
        return this.serializeAsHorizontalRule(t);
      case r.MESSENGER_CARD:
        return this.serializeAsMessengerCard(t);
      case r.TABLE:
        return this.serializeAsTable(t);
      case r.ORDERED_NESTED_LIST:
      case r.UNORDERED_NESTED_LIST:
        return this.serializeAsNestedList(t);
      case r.HTML:
        return this.serializeHtmlBlock(t);
      case r.TWITTER_FOLLOW_BUTTON:
        return this.serializeTwitterFollowButton(t);
      case r.FACEBOOK_LIKE_BUTTON:
        return this.serializeFacebookLikeButton(t);
      case r.SOCIAL:
        return this.serializeAsSocial(t);
      case r.SPACER:
        return this.serializeAsSpacer(t);
      case r.CALLOUT:
        return this.serializeCallout(t);
      case r.COLLAPSIBLE_SECTION:
        return this.serializeAsCollapsibleSection(t);
      case r.UNSUPPORTED_ELEMENT:
        return this.serializeAsUnsupportedElement(t);
    }
  }
  serializeTwitterFollowButton(t) {
    const e = t.attrs;
    return {
      type: e.type,
      username: e.username
    };
  }
  serializeFacebookLikeButton(t) {
    const e = t.attrs;
    return {
      type: e.type,
      url: e.url
    };
  }
  isHeadingBlock(t) {
    return t.type === "heading" || t.type === "subheading" || t.type === "subheading3" || t.type === "subheading4";
  }
  serializeTextBlock(t) {
    const e = t.attrs, s = { type: e.type, text: "" };
    return this.addAlignment(s, t), this.addStyle(s, t), s.type === "paragraph" && this.config.allowEmptyParagraphs && (s.allowEmpty = !0), s.type === "paragraph" && !this.config.allowImplicitMarginParagraphs && (s.class = u), s.text = new o(this.schema, this.config).serializeNode(t), this.isHeadingBlock(s) && (s.idAttribute = e.idAttribute), s;
  }
  serializeHtmlBlock(t) {
    const e = t.attrs, s = {
      type: e.type,
      content: "",
      header: null,
      footer: null
    };
    return s.content = e.content ?? "", s;
  }
  serializeIfElseStatement(t) {
    const e = t.attrs;
    return {
      type: e.type,
      fallbackBlocks: e.fallbackBlocks ?? [],
      predicatesBlocksPairs: e.predicatesBlocksPairs ?? []
    };
  }
  serializeAsImage(t) {
    const e = t.attrs, s = { type: e.type, url: "" };
    return this.addAlignment(s, t), s.url = e.src, e.linkUrl && (s.linkUrl = e.linkUrl), e.width && (s.width = Number(e.width)), e.height && (s.height = Number(e.height)), e.displayWidth && (s.displayWidth = Number(e.displayWidth)), e.text && (s.text = e.text), s;
  }
  serializeAsImageText(t) {
    const e = t.attrs;
    return {
      type: e.type,
      imageUrl: e.imageUrl ?? "",
      title: e.title,
      text: e.text
    };
  }
  serializeAsList(t) {
    const s = { type: t.attrs.type, items: [] };
    return this.addStyle(s, t), t.content.forEach((i) => {
      s.items.push(
        new o(this.schema).serializeNode(i.content.firstChild)
      );
    }), s;
  }
  serializeAsNestedList(t) {
    const e = t.attrs, s = [];
    return t.content.forEach((i) => {
      s.push(this.serializeAsNestedListItem(i));
    }), {
      type: e.type,
      items: s
    };
  }
  serializeAsNestedListItem(t) {
    const e = [];
    return t.content.forEach((s) => {
      const i = this.serializeBlock(s);
      i && e.push(i);
    }), { content: e };
  }
  serializeAsVideo(t) {
    const e = t.attrs;
    return {
      type: e.type,
      provider: e.provider,
      id: e.id
    };
  }
  serializeAsVideoFile(t) {
    const e = t.attrs;
    return {
      type: e.type,
      thumbnailUrl: e.thumbnailUrl,
      url: e.url,
      captions: e.captions
    };
  }
  serializeAsAudioFile(t) {
    const e = t.attrs;
    return {
      type: e.type,
      url: e.url
    };
  }
  serializeAsButton(t) {
    const e = t.attrs;
    let s = d(e.text);
    s = s.replace(/&quot;/g, '"');
    const i = {
      type: e.type,
      text: s,
      linkUrl: e.linkUrl,
      buttonStyle: e.buttonStyle
    };
    return this.addAlignment(i, t), this.addStyle(i, t), this.addPadding(i, t), i;
  }
  serializeAsHorizontalRule(t) {
    const s = {
      type: t.attrs.type,
      text: p
    };
    return this.addNodeWidth(s, t), this.addBorderStyles(s, t), s;
  }
  serializeAsMessengerCard(t) {
    const e = t.attrs;
    return {
      type: "messengerCard",
      canvas: e.canvas,
      text: e.text,
      // TODO: need to check if messenger_app_id should be number
      // @ts-expect-error - messenger_app_id is not typed
      messenger_app_id: e.messenger_app_id,
      uri: e.uri
    };
  }
  serializeAsTable(t) {
    const e = t.attrs, s = [], i = e.container, a = e.responsive;
    t.content.forEach((n) => {
      s.push(this.serializeAsTableRow(n, i));
    });
    const l = {
      type: e.type,
      responsive: e.responsive,
      container: i,
      rows: s
    };
    return typeof e.stacked == "boolean" && (l.stacked = e.stacked), (i || a) && (this.addStyle(l, t), this.addPadding(l, t)), e.sectionType && (l.sectionType = e.sectionType), l;
  }
  serializeAsTableRow(t, e) {
    const s = [];
    return t.content.forEach((i) => {
      s.push(this.serializeAsTableCell(i, e));
    }), { cells: s };
  }
  serializeAsTableCell(t, e) {
    const s = t.attrs, i = [];
    t.content.forEach((l) => {
      const n = this.serializeBlock(l);
      n && i.push(n);
    });
    const a = { content: i };
    return e && this.addPadding(a, t), e || this.addBackgroundColor(a, t), s.colwidth && s.colwidth.length > 0 && (a.displayWidth = s.colwidth[0]), a;
  }
  serializeAsSocial(t) {
    const e = t.attrs, s = {
      type: e.type,
      items: e.items ?? []
    };
    return this.addAlignment(s, t), s;
  }
  serializeAsSpacer(t) {
    const e = t.attrs;
    return {
      type: e.type,
      height: e.height
    };
  }
  serializeCallout(t) {
    const e = t.attrs, s = [];
    return t.content.forEach((i) => {
      const a = this.serializeBlock(i);
      a && s.push(a);
    }), {
      type: e.type,
      content: s,
      style: {
        backgroundColor: e.backgroundColor,
        borderColor: e.borderColor
      }
    };
  }
  serializeAsUnsupportedElement(t) {
    const e = t.attrs;
    return {
      type: e.type,
      unsupportedTypeName: e.unsupportedTypeName,
      text: e.text,
      category: "unsupported"
    };
  }
  serializeAsCollapsibleSection(t) {
    const e = t.attrs;
    let s, i = [];
    return t.content.forEach((a) => {
      const l = a.attrs;
      l.type === r.COLLAPSIBLE_SECTION_SUMMARY ? s = this.serializeCollapsibleSectionSummary(a) : l.type === r.COLLAPSIBLE_SECTION_CONTENT && (i = this.serializeCollapsibleSectionContent(a));
    }), {
      type: e.type,
      summary: s,
      content: i
    };
  }
  serializeCollapsibleSectionSummary(t) {
    const e = {
      type: "paragraph",
      text: ""
    };
    let s;
    return t.content.firstChild && (s = this.serializeBlock(t.content.firstChild)), s || e;
  }
  serializeCollapsibleSectionContent(t) {
    const e = [];
    return t.content.forEach((s) => {
      const i = this.serializeBlock(s);
      i && e.push(i);
    }), e;
  }
  addAlignment(t, e) {
    const i = e.attrs.alignment;
    i && i !== h && (t.align = i);
  }
  addNodeWidth(t, e) {
    const i = e.attrs.width;
    i && (t.width = i);
  }
  addBackgroundColor(t, e) {
    const i = e.attrs.backgroundColor;
    i && (t.style = {
      ...t.style,
      backgroundColor: i
    });
  }
  addBorderStyles(t, e) {
    if (this.config.customStylesConfig?.allowCustomStyles) {
      const s = e.attrs, { borderColor: i, borderStyle: a, borderWidth: l } = s;
      (i || a || l) && (t.style = {
        ...t.style,
        ...i && { borderColor: i },
        ...a && { borderStyle: a },
        ...l && { borderWidth: l }
      });
    }
  }
  addStyle(t, e) {
    if (this.config.customStylesConfig?.allowCustomStyles) {
      const s = e.attrs, { fontFamily: i, fontColor: a, backgroundColor: l, borderRadius: n } = s;
      (i || a || l || n) && (t.style = {
        ...t.style,
        ...i && { fontFamily: i },
        ...a && { fontColor: a },
        ...l && { backgroundColor: l },
        ...n && { borderRadius: n }
      });
    }
  }
  addPadding(t, e) {
    if (this.config.customStylesConfig?.allowCustomStyles) {
      const s = e.attrs, { paddingTop: i, paddingBottom: a, paddingLeft: l, paddingRight: n } = s;
      (i || a || l || n) && (t.style = {
        ...t.style,
        ...i && { paddingTop: i },
        ...a && { paddingBottom: a },
        ...l && { paddingLeft: l },
        ...n && { paddingRight: n }
      });
    }
  }
  isIncompleteUpload(t) {
    return t.startsWith("blob");
  }
}
export {
  g as BlocksSerializer
};
